import { Dialog } from "primereact/dialog";
import React from "react";
import styles from "./index.module.scss";
import ButtonC from "../../../../stories/common/button";
import { useSendPropertyInfo } from "../../../../hooks/react-query/inv-exchange/useSendPropertyInfo";
import { useToast } from "../../../../stories/common/toast/toast";

export default function SendPropertyInfo({
  Visible,
  setVisible,
  pubPropertyId
}: {
  Visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  pubPropertyId?: string;
}) {
  const { showError }: any = useToast();
  const SendPropertyInfoMutation = useSendPropertyInfo(
    (data: any) => {
      setVisible(false);
    },
    (error) => {
      showError("error", error.response.data.message || "something went wrong");
    }
  );
  return (
    <Dialog
      visible={Visible}
      closable={false}
      closeOnEscape={true}
      maskClassName={styles.maskClassName}
      header="Send Property Info"
      onHide={() => {
        setVisible(false);
      }}
      className={styles.dialog}
      draggable={false}
      resizable={false}
    >
      <div className={styles.content}>
        <img src="/images/send.svg" alt="" />
        <div>
          We’ll email the investor the property details along with a link to
          explore it online.
        </div>
      </div>
      <div className={styles.btnWrap}>
        <ButtonC
          btnType="border"
          type="submit"
          tabIndex={7}
          size="small"
          className={styles.cancelBtn}
          label={"Cancel"}
          //   disabled={}
          onClick={() => {
            setVisible(false);
          }}
        />
        <ButtonC
          type="submit"
          tabIndex={7}
          size="small"
          label={"Send Email"}
          loading={SendPropertyInfoMutation.isPending}
          onClick={() => {
            if (pubPropertyId) {
              SendPropertyInfoMutation.mutate({
                pubPropertyId: pubPropertyId
              });
            }
          }}
          className={styles.subBtn}
        />
      </div>
    </Dialog>
  );
}
